import { I18n } from '@calendly/i18n'
import { Button } from '@calendly/ui/components/button'
import { useSelector, useDispatch } from 'react-redux'

import { ConfirmDeleteDialog } from './confirm_delete_dialog'
import { isNewSelector } from './selectors'
import { setDeleteDialogOpen } from './slice'

export const DestroySettings = ({ className }) => {
  const dispatch = useDispatch()
  const isNew = useSelector(isNewSelector)

  const openDialog = () => {
    dispatch(setDeleteDialogOpen(true))
  }

  return (
    <div className={className}>
      <ConfirmDeleteDialog />
      <Button decoration="danger" size="small" disabled={isNew} onClick={openDialog}>
        {I18n.t('publisher.organization_settings.sso.destroy_link')}
      </Button>
    </div>
  )
}
